import { browserSupportsWebAuthn, startAuthentication, startRegistration } from "@simplewebauthn/browser";
import { api } from "@tc/ui";
/** Face ID / Touch ID / Windows Hello / fingerprint, via passkeys. */
export const passkeySupported = () => typeof window !== "undefined" && browserSupportsWebAuthn();
/** What to call it on this device. */
export function biometricName() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad/.test(ua))
        return "Face ID";
    if (/Macintosh/.test(ua))
        return "Touch ID";
    if (/Android/.test(ua))
        return "fingerprint";
    if (/Windows/.test(ua))
        return "Windows Hello";
    return "passkey";
}
export async function registerPasskey() {
    const o = await api("/api/me/passkeys/options", { body: {} });
    const response = await startRegistration({ optionsJSON: o.options });
    await api("/api/me/passkeys/verify", { body: { ticket: o.ticket, response } });
}
/** Sign in with Face ID; after a password, `challenge` (from /api/auth/login) limits it to that person's passkeys. */
export async function signInWithPasskey(challenge) {
    const o = await api("/api/auth/passkey/options", { body: challenge ? { challenge } : {} });
    const response = await startAuthentication({ optionsJSON: o.options });
    await api("/api/auth/passkey/verify", { body: { ticket: o.ticket, response } });
}
export async function confirmWithPasskey() {
    const o = await api("/api/auth/step-up/passkey/options", { body: {} });
    const response = await startAuthentication({ optionsJSON: o.options });
    await api("/api/auth/step-up/passkey/verify", { body: { ticket: o.ticket, response } });
}
/** A cancelled Face ID prompt isn't an error worth showing. */
export const cancelled = (e) => e instanceof Error && (e.name === "NotAllowedError" || e.name === "AbortError");
